import styled from "styled-components";

type CommentsAndInputWrapperProps = {
  $show: boolean;
};

export const mentionStyle = {
  control: {
    backgroundColor: "#fff",
    fontSize: 14,
    fontWeight: "normal",
  },

  "&multiLine": {
    width: "100%",
    minHeight: "45px",
    maxWidth: "100%",
    maxHeight: "100%",

    control: {
      minHeight: 63,
      width: "100%",
      maxWidth: "100%",
    },
    highlighter: {
      padding: 9,
      border: "1px solid transparent",
    },
    input: {
      innerWidth: "100%",

      backgroundColor: "rgb(237, 237, 237)",
      borderRadius: "100px",
      padding: "12px 16px",
      resize: "none",
    },
  },

  "&singleLine": {
    width: "100%",
    display: "inline-block",

    highlighter: {
      padding: 1,
    },
    input: {
      padding: "14px 50px 14px 20px",
      borderRadius: "24px",
      backgroundColor: "#f0f0f0",
      boxSizing: "border-box",
      overflowWrap: "break-word",
      border: "1px solid #e0e0e0",
      fontSize: "15px",
      lineHeight: "1.6",
      width: "100%",
      minHeight: "48px",
      height: "auto",
      transition: "all 0.2s ease",
      "&:focus": {
        backgroundColor: "#fff",
        borderColor: "#007bff",
        outline: "none",
        boxShadow: "0 0 0 3px rgba(0, 123, 255, 0.1)",
      },
      "&::placeholder": {
        color: "#999",
        fontSize: "15px",
      },
    },
  },

  suggestions: {
    list: {
      backgroundColor: "white",
      border: "1px solid rgba(0,0,0,0.15)",
      fontSize: 14,
      maxHeight: "250px",
      overflow: "auto",
    },
    item: {
      padding: "5px 15px",
      borderBottom: "1px solid rgba(0,0,0,0.15)",
      "&focused": {
        backgroundColor: "#cee4e5",
      },
    },
  },
};

export const CommentsAndInputWrapper = styled.div<CommentsAndInputWrapperProps>`
  ${(props) =>
    !props.$show &&
    `
      opacity: 0;
      height: 0;
      overflow: hidden;
      transition: opacity 0.25s ease, height 0.25s ease;
    `}
  ${(props) =>
    props.$show &&
    `opacity: 1;
      height: auto;
      transition: opacity 0.25s ease, height 0.25s ease;
      margin: 24px 0px;
      overflow: auto;
      `}
`;

export const CommentSpacer = styled.div``;

export const CommentsWrapper = styled.div<{
  $hasOneComment: boolean;
  $fullHeight?: boolean;
  $showInput?: boolean;
}>`
  /** Better height handling - increased when input is hidden */
  ${(props) => {
    if (props.$fullHeight) {
      return `height: 100%;`;
    }
    if (props.$hasOneComment) {
      // Single comment should size naturally without internal scrollbars.
      return `max-height: none;`;
    }
    if (props.$showInput) {
      // When input is shown, use smaller height
      return `max-height: 200px;`;
    } else {
      // When input is hidden, use larger height for better scrolling
      return `max-height: 400px;`;
    }
  }}
  ${(props) => !props.$hasOneComment && `
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;
    
    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 10px;
      
      &:hover {
        background: #a8a8a8;
      }
    }
  `}
  ${(props) => props.$hasOneComment && `
    overflow: visible;
    padding-right: 0;
  `}
  margin-top: ${(props) => props.$showInput ? "24px" : "0"};
`;

export const CommentInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 8px;
  padding: 8px 0;
  transition: opacity 0.4s ease-out;
  width: 100%;
`;
